import { render, staticRenderFns } from "./opsCallback__form.vue?vue&type=template&id=33ab84fb"
import script from "./opsCallback__form.vue?vue&type=script&lang=js"
export * from "./opsCallback__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports